// TODO(WEB): Switch to three-platform lib like react-native-dotenv
// https://www.npmjs.com/package/react-native-dotenv

export default {
  getConstants: () => [],
}
